<template>
  <VAutocomplete
    :value="selected"
    v-bind="$attrs"
    :items="countries"
    :label="$t('headers.country')"
    :hint="$t('form.country_display')"
    item-text="name"
    item-value="id"
    @input="e => $emit('input', e)"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Countries',
  inheritAttrs: false,
  model: {
    prop: 'selected',
  },
  props: {
    selected: {
      type: Array,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('dictionary', [
      'countries',
    ]),
  },
  created() {
    this.loadCountries();
  },
  methods: {
    ...mapActions('dictionary', ['loadCountries']),
  },
};
</script>
